module.exports = __webpack_public_path__ + "static/media/secmed.1874dc04.jpg";